import React from 'react';
import { motion } from 'framer-motion';
export function RecipeCountSection() {
  return <section className="bg-white py-12 md:py-16 px-4" data-id="element-181">
      <div className="max-w-3xl mx-auto text-center" data-id="element-182">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-bold text-[#1f2e10] mb-8 md:mb-10 leading-tight" data-id="element-183">
          Ci sono oltre 200 ricette semplici e facili, pronte in meno di 15
          minuti e{' '}
          <span className="text-green-600" data-id="element-184">
            così buone che tuo figlio chiederà il bis prima di finire!
          </span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative max-w-md mx-auto rounded-3xl overflow-hidden shadow-xl" data-id="element-185">
          <img src="https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&q=80&w=1000" alt="Piatto sano e colorato per bambini" className="w-full h-auto object-cover" data-id="element-186" />
        </motion.div>
      </div>
    </section>;
}